import React, { useState } from 'react';
import { docsTypes } from '../../../initial-values';
import UbbeModalHeader from '../../global-components/modalHeader';
import fileIcon from '../../../assets/icons/new_icon/FileIcon.svg';
import smallDel from '../../../assets/icons/new_icon/smallDel.svg';
import delIcon from '../../../assets/icons/new_icon/delete-2.svg';
interface Props {
  setShowAddShipmentDocModal: any;
  setDocArray: any;
  docArray: any;
}
const AddShippingDocs = ({
  setShowAddShipmentDocModal,
  setDocArray,
  docArray,
}: Props) => {
  const [document, setDocument] = useState<any>(null);
  const [fileName, setFileName] = useState('');
  const [validating, setValidating] = useState(false);
  const [type, setType] = useState('-1');
  const [uploadProgress, setUploadProgress] = useState(0);
  const [fileError, setFileError] = useState('');
  const [loading, setLoading] = useState(false);
  const CHUNK_SIZE = 8192;

  const invalidFileTypes = ['exe', 'zip'];

  const addShipmentDoc = () => {
    setValidating(true);
    if (type !== '-1' && document  && !fileError) {
      let data = {
        document: document,
        file_name: fileName,
        type: type,
      };
      const fileExists = docArray.some(
        (doc: any) => doc.file_name === fileName && doc.type === type
      );
      if (fileExists) {
        alert('Document with the same file name already exists.');
      } else {
        setDocArray((prevDocArray: any) => [...prevDocArray, data]);
        setShowAddShipmentDocModal(false);
      }
    }
  };
  const handleClose = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      setShowAddShipmentDocModal(false);
    }
  };
  const handleFileChange = (e: any) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (invalidFileTypes.includes(fileExtension)) { 
        setFileError('Please upload a valid document.'); 
        setFileName(''); 
        setDocument(null); 
        return; 
      }

      setFileName(file.name); 
      setFileError(''); 

      const reader = new FileReader();

      reader.onload = (event: ProgressEvent<FileReader>) => {
        if (event.target) {
          const result = event.target.result;
          if (typeof result === 'string') {
            setDocument(
              result
                .split(',')[1]
                .replace('dataapplication/octetstreambase64', '')
            );
            console.log('heheheheh', result);
          }
        }
      };

      reader.onerror = (event) => {
        console.error('File reading error:', event);
      };

      reader.onloadend = () => {
        handleUpload();
      };

      reader.readAsDataURL(file);
    }
  };

  const handleUpload = () => {
    // Simulate upload progress
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      setUploadProgress(progress);
      if (progress >= 100) {
        clearInterval(interval);
      }
    }, 1000);
  };

  const handleDelete = () => {
    setDocument('');
    setFileName('');
    setUploadProgress(0);
  };

  return (
    <div
      className='modal'
      id='document_modal'
      tabIndex={-1}
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5) ' }}
      aria-labelledby='document_modal_label'
      aria-hidden='true'
      onClick={handleClose}
    >
      <div className='modal-dialog modal-md'>
        <div className='modal-content'>
          <UbbeModalHeader
            headerText='Add Document'
            onClose={() => setShowAddShipmentDocModal(false)}
          />
          <div className='modal-body'>
            <div className='mb-3'>
              <input type='text' id='document_id' className='d-none' />
              <label
                htmlFor='doc_type'
                className='form-label lex-18-400 color-black'
              >
                Type
                <span className='text-danger'>*</span>
              </label>
              <select
                className={`form-select dropdown-style w-100 custom-select ${
                  type ? 'custom-select-selected' : 'custom-select-notselected '
                } '`}
                id='doc_type'
                aria-label='Leg'
                value={type}
                defaultValue={type}
                onChange={(e) => {
                  setType(e.target.value);
                }}
              >
                {docsTypes &&
                  docsTypes.length > 0 &&
                  docsTypes.map((option: any) => (
                    <option
                      key={option.value}
                      value={option.value}
                      className='modal-box-edit'
                    >
                      {option.name}
                    </option>
                  ))}
              </select>
              {validating && type === '-1' && (
                <div className='error_text'>Please select a document type.</div>
              )}
            </div>
            <div>
              <p id='doc_type_description'></p>
            </div>
            {!fileName && (
              <div
                className={`${
                  validating || fileError
                    ? 'upload-file-container error-border'
                    : ' upload-file-container '
                }`}
              >
                <div className='d-flex gap-1 align-items-center m-auto justify-content-center '>
                  <img
                    style={{ width: '15px' }}
                    alt='file icon'
                    src={fileIcon}
                  />
                  <label
                    htmlFor='file'
                    className='custom-file-upload'
                    onChange={handleFileChange}
                  >
                    Choose File
                  </label>
                </div>

                <input
                  type='file'
                  id='file'
                  className=' custom-file-upload d-none '
                  onChange={handleFileChange}
                />
              </div>
            )}
            {fileError ? (<div className="error_text">{fileError}</div>)
            : validating && !document ? (
              <div className='error_text'>Please select a document.</div>
            )
            : ""
            } 
            {fileName && (
              <div className='file-info'>
                <div className='d-flex justify-content-between '>
                  <div style={{ width: '100%' }}>
                    <div className='d-flex align-items-center gap-1'>
                      <img src={fileIcon} alt='file icon' />{' '}
                      <span className='createdby'>{fileName}</span>
                    </div>
                    {uploadProgress < 100 ? (
                      <div className='progress-container'>
                        <div
                          className='progress-bar mb-0 ms-3 '
                          style={{ width: `${uploadProgress}%` }}
                        />
                        <div className='progress-text mt-2 ms-3 '>
                          {uploadProgress}%
                        </div>
                      </div>
                    ) : (
                      <>
                        <p
                          className='tooltip-text mb-0 ms-3 my-2'
                          style={{ color: '#00B998' }}
                        >
                          Uploaded
                        </p>
                      </>
                    )}{' '}
                  </div>
                  {uploadProgress < 100 ? (
                    <div
                      onClick={handleDelete}
                      className='d-flex justify-content-between align-items-baseline '
                    >
                      <img src={smallDel} alt='delete icon' />
                    </div>
                  ) : (
                    <div className='d-flex justify-content-between align-items-baseline   '>
                      <button className='delete-button' onClick={handleDelete}>
                        <img src={delIcon} alt='delete icon' />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
            <div className='mt-4 d-flex pt-0 pb-2  flex-column  justify-content-center '>
              <p
                className='btn m-auto  ubbe-blue-bg p-2 px-4 rounded-3 text-light'
                onClick={addShipmentDoc}
                style={{
                  width: 'max-content',
                  backgroundColor: '#251163',
                  fontFamily: 'Lexend',
                }}
              >
                Add Document
              </p>
              <u
                className='m-auto mt-2 d-flex justify-content-center labelText'
                style={{ cursor: 'pointer' }}
                onClick={() => setShowAddShipmentDocModal(false)}
              >
                Close
              </u>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddShippingDocs;
